cb.define(function() {
  var AA_sys_option_VM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function(viewmodel) {

      /*viewmodel.get('daytimepoint').setState('multiple', true);
		
      viewmodel.on("afterLoad", function(data) {
      	var timepoint = viewmodel.get('timepoint').getValue();
      	if(timepoint === "1")
      		viewmodel.get('daytimepoint').setVisible(false);
      	else
      		viewmodel.get('daytimepoint').setVisible(true);
      });*/

      viewmodel.get('autoTagDailyTime').setState('multiple', true);
      viewmodel.get('pwd-strength').setState('multiple', true);

    viewmodel.on("beforeSave", function(args) {
        var password = viewmodel.get("defaultpassword").getData();
        if (password == null || password == '') {
          cb.utils.alert("请设置默认密码！");
          return false;
        }
        return true;
      });

     /* viewmodel.get("ERPsysaddress") && viewmodel.get("ERPsysaddress").on("afterValueChange", function(data) {
        var value = data.value.value;
        if (value != "0") {
          var account = viewmodel.get("account");
          if (account) {
            account.clear();
          }
          var password = viewmodel.get("password");
          if (password) {
            password.clear();
          }
          var datasource = viewmodel.get("datasource");
          if (datasource) {
            datasource.clear();
          }
        }
      });*/
      /*viewmodel.get('timepoint').on('afterValueChange', function(data) {
      		if(data.value.value === "1") {
      			viewmodel.get('daytimepoint').setVisible(false);
      		} else {
      			viewmodel.get('daytimepoint').setVisible(true);

      		}
      	});*/
      /*viewmodel.get('daytimepoint').on('beforeValueChange', function(data) {
      	if(data.value.length > 5) {
      		cb.utils.alert('所选时点不能超过5个', 'warning');
      		return false;
      	}
      });*/
    }
  }
  try {
    module.exports = AA_sys_option_VM_Extend;
  } catch (error) {

  }
  return AA_sys_option_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_sys_option_VM.Extend.js